<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-collect-point"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="text-title">{{localePage.scan_qr.title}}</div>
                    <div class="wrapper-btn">
                        <div class="section-btn">
                            <div class="btn-row">
                                <div class="btn-camera" @click="openCamera()">{{localePage.scan_qr.text_camera}} / {{localePage.scan_qr.text_select_image}}</div>
                            </div>
                        </div>
                        <!-- <div class="text-or">{{localePage.scan_qr.text_or}}</div> -->
                        <!-- <div class="section-btn">
                            <div class="btn-row">
                                <form>
                                    <label for="select_image_code" class="input-custom-capture">
                                        {{localePage.scan_qr.text_select_image}}
                                    </label>
                                    <qrcode-capture
                                        id="select_image_code" 
                                        @detect="onDetect"
                                        :capture="selected.value"
                                        class="input-capture"/>
                                </form>
                            </div>
                        </div> -->
                    </div>
                    <div class="text-condition" v-html="localePage.scan_qr.text_condition"></div>
                    <div>
                        <TextInput
                            v-model="serialCode"
                            inputId="serial_code"
                            :inputLbl="localePage.code"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="false"
                            :errorInfo="errorInfo[0]"/>
                        <div class="text-code-error" v-if="errorText" v-html="errorText"></div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-submit" @click="clickConfirm()">
                        <div class="btn-txt">
                            {{localePage.scan_qr.btn_confirm}}
                        </div>
                    </div>
                    <div class="btn-cancel" @click="hide()">
                        <div class="btn-txt">
                            {{localePage.scan_qr.btn_cancel}}
                        </div>
                    </div>
                    <div class="text-contact" v-html="localePage.scan_qr.text_contact"></div>
                    <div class="btn-line" @click="gotoLineChannel()">
                        <img src="@/assets/icon/ic-line.svg"/>
                        {{localePage.scan_qr.text_line_add}}
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// import { QrcodeCapture } from "vue-qrcode-reader";
// helper
import FormHelper from "@/helper/FormHelper.js";
import Util from "@/helper/Utility.js";
import CacheHelper from "@/helper/CacheHelper.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//import LineFunction from "@/helper/facade/LineFunction.js";
// mixins
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
// component
import TextInput from "@/components/Input/Text.vue";
// service
import CouponService from "@/core/Coupon/CouponService.js";
import ProductPointConfig from "@/core/ProductPointDetail/ProductPointConfig.js";

/**
 * @property {ProductCollectionModalController} controller (required)../Controller/ProductCollectionModalController.js
 * @property {String} modalId (reqquired)
 */

export default {
    name: "ProductCollectionModal",
    props: {
        controller: Object,
        modalId: String,
    },
    components: {
        TextInput,
        // QrcodeCapture
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",

            busModal: null,

            liffId: null,
            lineFunction: null,

            token: null,
            localePage: {},
            isFirstSave: true,
            errorInfo: [],
            error: null,
            camera: "auto",
            reInit: true,
            serialCode: null,
            skuCode: null,
            productMaster: [],
            productScan: null,

            autoCampaign: null,
            errorText: '',
            tracking: new TrackingService(this),

            selected: { text: 'force file dialog', value: null }
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(1);
        this.busModal = this.controller.busModal;
        this.localePage = this.lbl.qrcode;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        //modal
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            if(this.errorInfo[0].isValid){
                this.controller.sendCallbackOk({
                    tag: this.tag,
                    data: this.content
                });
                this.hide();
            }

            this.isFirstSave = false;
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;

            if(config.code){
                this.serialCode = config.code;
            }else{
                this.serialCode = "";
            }

            this.token = this.getToken();
            this.errorText = '';
            // this.lineFunction = new LineFunction();
            // this.initLiff();

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            console.log('cont',this.controller)
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.serialCode = '';
            this.isFirstSave = true;
            this.$bvModal.hide(this.modalId);
        },
        //line
        initLiff: function() {
            this.liffId = this.lineFunction.getLiffId();

            this.lineFunction.init(this.liffId).then(() => {
                var currentUrl = window.location.href;
                if (this.lineFunction.isLogin()) {
                    if (this.lineFunction.isTokenExpire()) {
                        this.lineFunction.logout();
                        this.lineFunction.login(currentUrl);
                        return;
                    }

                    this.idToken = this.lineFunction.getIdToken();

                } else {
                    this.lineFunction.login(currentUrl);
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        getCodeFromLine: function(){
            this.lineFunction.scanCode().then((result) =>{
                //alert(result.value);
                console.log('res', result);
                //code
                if(result.value != null){
                    this.serialCode = result.value;
                    document.getElementById("serial_code").value = result.value;
                }

                console.log('scan code',this.serialCode);
            }).catch((err) => {
                alert(err);
                console.log(err);
            });
        },
        openCamera: function(){
            window.open("https://line.me/R/nv/QRCodeReader");
        },
        //method
        clickConfirm: function() {
            if(this.validateCode()){
                //get product SKU from API
                this.getProductSKU();

            }
            this.controller.sendCallbackOk(true);
            this.isFirstSave = false;
        },
        getProductSKU: function(){
            this.controller.loadingModal.show();
            CouponService.apiGetSKU(this.token, this.serialCode)
                .subscribe(res => {
                    this.controller.loadingModal.hide();
                    console.log('sku', res);

                    if(res.data){
                        var codes = res.data.codes;
                        if(codes){
                            switch (codes[this.serialCode].status){
                                case 'Success':
                                    this.skuCode = res.data.codes[this.serialCode].name;
                                    this.errorText = "";
                                    //get product detail from Blob
                                    this.getProductDetail();

                                    var cache = new CacheHelper('session');
                                    cache.removeCache('BDMCode');

                                    break;
                                case 'NotFound':
                                    this.errorText = this.localePage.errorText.notFound;
                                    break;
                                case 'Used':
                                    this.errorText = this.localePage.errorText.used;
                                    break;
                            }
                        }
                    }else{
                        if(res.code == 403){
                            this.errorText = this.localePage.errorText.suspend;
                        }
                    }

                    this.reInit = false;
                    this.$nextTick(() => {
                        this.reInit = true;
                    });

                },err => {
                    this.controller.loadingModal.hide();
                    this.errorApi(err);
                }
            );
        },
        getProductDetail: function(){
            this.controller.loadingModal.hide();
            ProductPointConfig.apiGetProductMaster().subscribe(res =>{
                console.log('product', res);
                this.productMaster = res;
                this.productScan = this.productMaster.filter(k => k.skucode == this.skuCode)[0];

                //show product description
                setTimeout(() =>{
                    this.controller.productDescriptionModal
                        .setTag('product-detail')
                        .setName(this.productScan.text)
                        .setDetail(this.productScan.description)
                        .setPoint(this.productScan.point)
                        .show();

                    this.controller.productDescriptionModal.onClickOk(res => {
                        var selected = res.data;
                        var shopName = res.shop;
                        var shop = '';

                        if(shopName){
                            shop = selected + '|' + shopName;
                        }else{
                            shop = selected;
                        }
                        this.callAPICoupon(shop);
                        this.tracking.event('confirm_collect_point', 'click_confirm_collect_point');
                    });
                },500)

            },err =>{
                this.controller.loadingModal.hide();
                this.errorApi(err);
            });
        },
        callAPICoupon: function(selected) {
            // detect inject code
            this.controller.loadingModal.show();
            this.autoCampaign = null;
            //call api
            CouponService.apiPostCoupon(this.token, this.serialCode, selected)
            .subscribe(res => {
                    console.log('point', res);
                    this.controller.loadingModal.hide();

                    //get point earn
                    var code_earn = res.data.codes[this.serialCode];
                    var point_earn = 0;
                    var isMission = false;

                    if(code_earn){
                        if(code_earn.status == 'Success'){
                            // point_earn = code_earn.detail.Points;
                            point_earn = code_earn.points_earn;

                            //auto redeem
                            if (code_earn.detail && code_earn.detail.buzzebees) {
                                var badges = code_earn.detail.buzzebees.badges;

                                if (badges) {
                                    console.log("badges", badges);

                                    var redeem = [];
                                    // badges.filter( o => {
                                    //     switch (o.id){
                                    //         case 'BiodermaCoupon4_23213185':
                                    //             isMission = true;
                                    //             redeem = o;
                                    //             break;
                                    //         case 'BiodermaCoupon1_23236914':
                                    //             isMission = false;
                                    //             redeem = o;
                                    //             break;
                                    //         case 'BiodermaCoupon6_23121751':
                                    //             isMission = false;
                                    //             redeem = o;
                                    //             break;
                                    //         case 'BiodermaCoupon6_Starbuck':
                                    //             isMission = false;
                                    //             redeem = o;
                                    //             break;
                                    //     }
                                    // })[0];
                                    badges.filter( o => {
                                        if(o.id.indexOf("BiodermaCoupon") >= 0){
                                            if(o.id.indexOf('BiodermaCoupon4') >= 0){
                                                isMission = true;
                                                redeem = o;
                                            }else{
                                                isMission = false;
                                                redeem = o;
                                            }
                                        }
                                    })[0];
                                    console.log("autoredeem", redeem);

                                    if(redeem && redeem.auto_redeem){
                                        this.autoCampaign = redeem.auto_redeem;
                                    }
                                }
                            }
                        }
                    }

                    //show summary modal
                    this.controller.pointSummaryModal
                        .setMission(isMission)
                        .setCampaign(this.autoCampaign)
                        .setPoint(point_earn)
                        .setTag('point-summary')
                        .show();

                    this.controller.pointSummaryModal.onClickOk((data) =>{
                        if(data.tag == 'point-summary'){
                            document.getElementById("serial_code").value = "";
                            this.serialCode = '';
                        }
                    });

                    this.controller.pointSummaryModal.onClickPage((data) =>{
                        if(data.tag == 'point-summary'){
                            this.$router.push('/history/earn');
                        }
                    });

                },err => {
                    this.controller.loadingModal.hide();
                    console.log(this.alertModal);
                    this.errorApi(err);
                }
            );
        },
        onDetect:async function (detectedCodes) {
            console.log('detectedCodes', detectedCodes);
            const result = await detectedCodes; // detectedCodes is return Promise. must use await for this case

            console.log('result', result);
        
            const code = this.getCodeFromUrl(result.content);

            this.serialCode = code;
            document.getElementById("serial_code").value = code;
            console.log('code',this.serialCode);

           this.errorText = '';
        },
        validateCode: function(){
            var code = this.serialCode;
            if(!code){
                this.errorText = this.localePage.code.required;
                return false;
            }

            return true;
        },
        getCodeFromUrl: function(data){
            var queryCode = data.split("?code=");
                console.log('q', queryCode)

                if(queryCode[1] != undefined){
                    return queryCode[1];
                }else{
                    return '';
                }
        },
        gotoLineChannel: function(){
            window.open('https://lin.ee/gKLuXJ3');
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseText.scss";
@import "@/style/base/baseUtility.scss";
@import "@/style/base/baseDisplay.scss";
@import "@/style/input/BaseButton.scss";
@import "../style/PointCollectionModal.scss";
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";
.modal-collect-point {
    @extend %modal-base;
    text-align: center;

    .modal-body {
        padding: 25px;

        .wrap-input{
            margin-top: 15px;
            .label{
                text-align: left;
            }
            .input-box{
                .input-field{
                    color: $bg-dark;
                    font-family: $semiBold;
                    font-size: 1.12rem;
                    text-align: center;

                    &::placeholder{
                        font-family: $regular;
                        text-align: center;
                    }
                }
            }
        }
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        max-height: 90vh;
        margin: auto;

        .modal-content {
            box-shadow: $box-shadow-bar;
            border-radius: 0;
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            border: 0;
        }
    }
}
</style>
